// New assessment route (/$region/assessments/new, Confidential): the chosen capability document in the URL (?doc=); the screen is NewAssessmentPage.
import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { z } from "zod";

import { optionalString } from "@/app/search";
import { RestrictedRoute } from "@/app/shell/RouteStates";
import { NewAssessmentPage } from "@/features/assessments/NewAssessmentPage";

const searchSchema = z.object({
  doc: optionalString(),
});

export const Route = createFileRoute("/_app/$region/assessments/new")({
  validateSearch: searchSchema,
  staticData: { crumb: "New assessment" },
  component: NewAssessmentRoute,
});

function NewAssessmentRoute() {
  const { doc } = Route.useSearch();
  const navigate = Route.useNavigate();
  const onDocChange = useCallback(
    (next: string) => {
      void navigate({ search: { doc: next }, replace: true });
    },
    [navigate],
  );
  return (
    <RestrictedRoute level="C" description="Compliance assessments are for users with the Confidential role.">
      <NewAssessmentPage doc={doc} onDocChange={onDocChange} />
    </RestrictedRoute>
  );
}
